<script setup>
import {ref} from "vue";
import AccordionPanel from "../layouts/AccordionPanel.ce.vue";
import QuestionGroup from "./QuestionGroup.ce.vue";

const props = defineProps({
    survey: {
        type: Object,
        default: () => {
            return {};
        },
    },
});
const categories = ref(props.survey.questions.categories);
</script>

<template>
    <AccordionPanel
        v-for="(category, index) in categories" :key="index"
        :index="index"
        :index-count="categories.length"
    >
        <template #title>
            {{category.label}}
        </template>
        <template #content>
            <div class="max-w-screen-sm">
                <QuestionGroup
                    :question-groups="category['question_groups']"
                    :survey="survey"
                />
            </div>
        </template>
    </AccordionPanel>
</template>